// Customer Care pages: pages/contact.html | register | warranty | faq
// Forms validate and confirm in the browser; connect them to email/Shopify to receive submissions.
(function () {
  const e = LC.escape;
  const EMAIL = 'hello@lechichair.com';

  const pages = {
    contact: {
      label: 'Contact Us',
      eyebrow: 'Customer Care',
      title: 'Contact Le Chic Beauty Customer Care',
      intro: 'Questions about an order, a hair tool, hair care or extensions? Email hello@lechichair.com or send a message below. Le Chic Beauty is at 1251 Sawgrass Corporate Parkway, Sunrise, FL 33323.',
      seoTitle: 'Contact Us | Le Chic Beauty Customer Care',
      meta: 'Contact Le Chic Beauty Customer Care at hello@lechichair.com or send a message about orders, hair tools, hair care, hair extensions or your warranty.'
    },
    register: {
      label: 'Register Your Tool',
      eyebrow: 'Lifetime Warranty',
      title: 'Register Your Le Chic Beauty Tool',
      intro: 'Register within 14 days of purchase to activate the Limited Lifetime Warranty on Le Chic Beauty hair tools bought from Le Chic Beauty or an authorized retailer.',
      seoTitle: 'Register Your Tool for the Lifetime Warranty | Le Chic Beauty',
      meta: 'Register your Le Chic Beauty hair tool within 14 days of purchase to activate the Limited Lifetime Warranty. Add your tool, purchase date and proof of purchase.'
    },
    warranty: {
      label: 'Warranty Claim',
      eyebrow: 'Warranty',
      title: 'Le Chic Beauty Tool Warranty Claim',
      intro: 'Is your Le Chic Beauty hair tool not working as it should? Submit a warranty claim with your proof of purchase and photos, and the Warranty Department will review it in about 3–5 business days.',
      seoTitle: 'Hair Tool Warranty Claim | Le Chic Beauty',
      meta: 'Submit a Le Chic Beauty tool warranty claim with proof of purchase and photos or videos of the defect. Claims are reviewed in about 3–5 business days.'
    },
    faq: {
      label: 'FAQ',
      eyebrow: 'Ask Le Chic Beauty',
      title: 'Le Chic Beauty FAQ',
      intro: 'Answers about Le Chic Beauty orders, shipping times, returns, the Limited Lifetime Warranty and halo hair extensions.',
      seoTitle: 'FAQ: Orders, Shipping, Returns, Warranty & Extensions | Le Chic Beauty',
      meta: 'Le Chic Beauty FAQ: same-day order cancel before ship, shipping in 1–2 business days, 30-day returns, the Limited Lifetime Warranty and halo hair extension care.'
    }
  };

  let key = LC.param('p');
  if (!pages[key]) key = 'contact';
  const page = pages[key];
  const files = { contact: 'contact', register: 'register-your-tool', warranty: 'warranty-claim', faq: 'faq' };
  const path = LC.pageUrl(files[key]);

  const today = new Date().toISOString().slice(0, 10);
  const tools = LC.inCollection('tools');

  /* ---------- Field helpers ---------- */
  const field = (id, label, control, opts = {}) => `
    <div class="hf${opts.full ? ' hf-full' : ''}${opts.hidden ? ' is-hidden' : ''}" data-field="${id}">
      <label for="${id}">${e(label)}${opts.required ? '' : ' <span class="hf-opt">Optional</span>'}</label>
      ${control}
      ${opts.hint ? `<p class="hf-hint">${e(opts.hint)}</p>` : ''}
      <p class="hf-error" id="${id}-error" aria-live="polite"></p>
    </div>`;
  const input = (id, type, opts = {}) =>
    `<input id="${id}" name="${id}" type="${type}"${opts.required ? ' required' : ''}${opts.autocomplete ? ` autocomplete="${opts.autocomplete}"` : ''}${opts.max ? ` max="${opts.max}"` : ''}${opts.placeholder ? ` placeholder="${e(opts.placeholder)}"` : ''} aria-describedby="${id}-error">`;
  const select = (id, options, opts = {}) =>
    `<select id="${id}" name="${id}"${opts.required ? ' required' : ''} aria-describedby="${id}-error">
      <option value="">${e(opts.placeholder || 'Select')}</option>
      ${options.map((o) => `<option value="${e(o.value)}">${e(o.label)}</option>`).join('')}
    </select>`;
  const textarea = (id, opts = {}) =>
    `<textarea id="${id}" name="${id}" rows="5"${opts.required ? ' required' : ''}${opts.placeholder ? ` placeholder="${e(opts.placeholder)}"` : ''} aria-describedby="${id}-error"></textarea>`;
  const fileDrop = (id, label, opts = {}) => `
    <div class="hf hf-full" data-field="${id}">
      <span class="hf-label">${e(label)}${opts.required ? '' : ' <span class="hf-opt">Optional</span>'}</span>
      <label class="file-drop" for="${id}">
        ${LC.icon('bag')}
        <span class="file-drop-text"><strong>Choose ${opts.multiple ? 'files' : 'a file'}</strong> or drop ${opts.multiple ? 'them' : 'it'} here</span>
        <span class="file-drop-sub">${e(opts.hint || 'JPG, PNG or PDF')}</span>
        <span class="file-names" id="${id}-names"></span>
      </label>
      <input class="file-input" id="${id}" name="${id}" type="file" accept="${opts.accept || 'image/*,.pdf'}"${opts.multiple ? ' multiple' : ''}${opts.required ? ' required' : ''} aria-describedby="${id}-error">
      <p class="hf-error" id="${id}-error" aria-live="polite"></p>
    </div>`;
  const check = (id, text, opts = {}) => `
    <div class="hf hf-full hf-check" data-field="${id}">
      <label class="check"><input id="${id}" name="${id}" type="checkbox"${opts.required ? ' required' : ''} aria-describedby="${id}-error"><span>${text}</span></label>
      <p class="hf-error" id="${id}-error" aria-live="polite"></p>
    </div>`;

  const nameFields = `
    ${field('first-name', 'First name', input('first-name', 'text', { required: true, autocomplete: 'given-name' }), { required: true })}
    ${field('last-name', 'Last name', input('last-name', 'text', { required: true, autocomplete: 'family-name' }), { required: true })}
    ${field('email', 'Email', input('email', 'email', { required: true, autocomplete: 'email' }), { required: true })}
    ${field('phone', 'Phone', input('phone', 'tel', { autocomplete: 'tel' }))}`;

  const toolFields = `
    ${field('product', 'Product', select('product', tools.map((p) => ({ value: p.id, label: p.name })), { required: true, placeholder: 'Select your tool' }), { required: true })}
    ${field('color', 'Color', select('color', [], { placeholder: 'Select a color' }), { hidden: true })}
    ${field('purchase-date', 'Date of purchase', input('purchase-date', 'date', { required: true, max: today }), { required: true })}`;

  /* ---------- Forms ---------- */
  const forms = {
    contact: {
      submit: 'Send Message',
      success: (first, extra) => `Thank you, ${first}. Your message is with our Customer Care team, and we’ll reply to your email.${extra || ''}`,
      html: `
        ${nameFields}
        ${field('topic', 'How can we help?', select('topic', [
          'Order question', 'Product question', 'Returns & exchanges', 'Hair extensions', 'Warranty', 'Salon & wholesale', 'Something else'
        ].map((t) => ({ value: t, label: t })), { required: true, placeholder: 'Choose a topic' }), { required: true })}
        ${field('order', 'Order number', input('order', 'text', { placeholder: 'e.g. #1024' }))}
        ${field('message', 'Message', textarea('message', { required: true, placeholder: 'Tell us a little more…' }), { required: true, full: true })}`
    },
    register: {
      submit: 'Register My Tool',
      success: (first, extra) => `Thank you, ${first}. Your tool is registered. Keep your proof of purchase somewhere safe; you’ll need it for any warranty claim.${extra || ''}`,
      html: `
        ${nameFields}
        ${toolFields}
        ${field('purchased-from', 'Where did you buy it?', select('purchased-from', [
          { value: 'lechic', label: 'Le Chic Beauty website' },
          { value: 'retailer', label: 'Authorized retailer' }
        ], { required: true }), { required: true })}
        ${field('retailer', 'Retailer name', input('retailer', 'text'), { hidden: true })}
        ${field('order', 'Order or receipt number', input('order', 'text', { required: true }), { required: true })}
        ${fileDrop('receipt', 'Proof of purchase', { required: true, hint: 'JPG/PNG/PDF under ~2MB preferred. Larger files: email to hello@lechichair.com after submit.' })}
        ${check('updates', 'Send me launches, styling tips and exclusive offers.')}`
    },
    warranty: {
      submit: 'Submit Claim',
      success: (first, extra) => `Thank you, ${first}. Your claim has been submitted. Our Warranty Department reviews claims within approximately 3–5 business days and will email you with next steps.${extra || ''}`,
      html: `
        ${nameFields}
        ${toolFields}
        ${field('order', 'Order number or proof of purchase reference', input('order', 'text', { required: true }), { required: true, full: true })}
        ${field('issue', 'What’s happening?', textarea('issue', { required: true, placeholder: 'Describe the issue: when it started, what the tool does or doesn’t do…' }), { required: true, full: true })}
        ${fileDrop('media', 'Photos or videos of the issue', { required: true, multiple: true, accept: 'image/*,video/*,.pdf', hint: 'Photos (JPG/PNG) under ~2MB attach in the form. Videos and large files: email to hello@lechichair.com after submit.' })}
        <p class="hf-group hf-full">Return shipping address</p>
        ${field('address', 'Street address', input('address', 'text', { required: true, autocomplete: 'street-address' }), { required: true, full: true })}
        ${field('city', 'City', input('city', 'text', { required: true, autocomplete: 'address-level2' }), { required: true })}
        ${field('state', 'State / Province', input('state', 'text', { required: true, autocomplete: 'address-level1' }), { required: true })}
        ${field('zip', 'ZIP / Postal code', input('zip', 'text', { required: true, autocomplete: 'postal-code' }), { required: true })}
        ${field('country', 'Country', input('country', 'text', { required: true, autocomplete: 'country-name' }), { required: true })}
        ${check('ack', 'I understand approved claims submitted more than 30 days after purchase are subject to a shipping and handling fee, and I may be asked for a photo of the product with the power cord cut.', { required: true })}
        <p class="hf-hint hf-full">You must check the box above before Submit Claim.</p>`
    }
  };

  /* ---------- Asides ---------- */
  const asides = {
    contact: `
      <div class="help-aside">
        <h2>Reach us directly</h2>
        <p>Email <a href="mailto:${EMAIL}">${EMAIL}</a></p>
        <p class="aside-address">1251 Sawgrass Corporate Parkway<br>Sunrise, FL 33323</p>
        <ul class="aside-list">
          <li><strong>Change or cancel an order</strong><span>Email us the same day you place it — before it ships. Once shipped, orders cannot be cancelled.</span></li>
          <li><strong>Missing an item?</strong><span>Let us know as soon as possible and we’ll make it right.</span></li>
          <li><strong>Shipping</strong><span>Orders typically ship within 1–2 business days, with tracking. Same-day cancel before ship; once shipped, use the 30-day return/refund window.</span></li>
        </ul>
        <a class="link-arrow" href="pages/faq.html">Browse the FAQ <span aria-hidden="true">→</span></a>
      </div>`,
    register: `
      <div class="help-aside">
        <h2>What’s covered</h2>
        <ul class="aside-list">
          <li><strong>Manufacturing defects</strong></li>
          <li><strong>Faulty materials</strong></li>
          <li><strong>Defective craftsmanship</strong></li>
          <li><strong>Premature mechanical or electrical failure</strong><span>Not caused by misuse.</span></li>
        </ul>
        <p class="aside-note">Register within <strong>14 days</strong> of purchase and keep your proof of purchase. Tools bought from unauthorized sellers, including Amazon, eBay and other resale platforms, aren’t eligible.</p>
        <a class="link-arrow" href="pages/warranty-claim.html">Need to make a claim? <span aria-hidden="true">→</span></a>
      </div>`,
    warranty: `
      <div class="help-aside">
        <h2>How a claim works</h2>
        <ol class="aside-steps">
          <li><strong>Submit your claim</strong><span>Tell us about the tool and the issue.</span></li>
          <li><strong>Share documentation</strong><span>Proof of purchase, photos or videos of the defect, and a photo of the complete product.</span></li>
          <li><strong>Review</strong><span>Allow approximately 3–5 business days.</span></li>
          <li><strong>Resolution</strong><span>We repair the tool or replace it with the same model, or a comparable one of equal or greater value.</span></li>
        </ol>
        <p class="aside-note">Claims within <strong>30 days</strong> of purchase ship free within the contiguous United States. Later approved claims carry a shipping and handling fee, shared during the claim.</p>
        <a class="link-arrow" href="pages/warranty-policy.html">Read the full warranty policy <span aria-hidden="true">→</span></a>
      </div>`
  };

  /* ---------- FAQ ---------- */
  const faqGroups = [
    { title: 'Ordering', items: [
      ['Can I cancel or change my Le Chic Beauty order?', `Yes. You may cancel or change a Le Chic Beauty order the same day it is placed, before it ships, by emailing ${EMAIL}. Once shipped, orders cannot be cancelled — you may request a return/refund within 30 days of delivery.`],
      ['What should I do if an item is missing from my Le Chic Beauty order?', `Email ${EMAIL} as soon as possible and a Le Chic Beauty Customer Care specialist will help resolve it.`]
    ] },
    { title: 'Shipping', items: [
      ['How long does Le Chic Beauty take to ship an order?', 'Le Chic Beauty typically ships orders within 1–2 business days of purchase, with tracking. You may cancel the same day your order is placed, before it ships. Once shipped, orders cannot be cancelled.'],
      ['How do I track my Le Chic Beauty order?', 'Once your order ships, Le Chic Beauty emails a shipping confirmation with your tracking number so you can follow your package.']
    ] },
    { title: 'Returns', items: [
      ['What is the Le Chic Beauty return policy?', 'If your order has already shipped, you may request a return/refund within 30 days of delivery for orders placed directly with Le Chic Beauty. Return shipping is paid by the customer. A 10% restocking fee applies to unused, unopened items and a 30% restocking fee applies to used or opened items.'],
      ['Can I return Le Chic Beauty products bought from another store?', 'No. Le Chic Beauty products bought anywhere other than the Le Chic Beauty website follow that retailer’s own return and exchange policy.']
    ] },
    { title: 'Warranty', items: [
      ['Do Le Chic Beauty hair tools have a warranty?', 'Yes. Le Chic Beauty hair tools purchased from Le Chic Beauty or an authorized retailer are covered by a Limited Lifetime Warranty once the tool is registered.'],
      ['How long do I have to register my Le Chic Beauty hair tool?', 'You have 14 days from the date of purchase to register your Le Chic Beauty hair tool. The warranty doesn’t apply to tools bought from unauthorized sellers.'],
      ['How do I make a Le Chic Beauty warranty claim?', 'Submit a warranty claim with your proof of purchase and clear photos or videos of the defect. The Le Chic Beauty Warranty Department reviews claims in approximately 3–5 business days.']
    ] },
    { title: 'Hair Extensions', items: [
      ['What is Remy human hair?', 'Remy hair is 100% never-processed, “virgin” human hair that keeps its cuticle layer, with every strand flowing in its natural direction, so there’s less risk of tangling or breakage.'],
      ['Do Le Chic Beauty halo extensions damage your hair?', 'No. Le Chic Beauty halo extensions fit without weaving, clips or glue. A fitted wire sits beneath your own hair, so you can enjoy fuller, longer hair in minutes.'],
      ['How do halo hair extensions stay in place?', 'The halo wire sits about one to three inches behind your hairline. Once you pull your hair over it, the weight of your natural hair keeps the halo secure. Optional clips are included for extra hold.'],
      ['Can I wear halo extensions with my current extensions?', 'Yes. You can wear Le Chic Beauty halo extensions with other extensions for a fuller, more voluminous look.'],
      ['How long do Le Chic Beauty halo extensions last?', 'With regular care, Le Chic Beauty halo extensions should last nine months or longer. As they’re human hair, there’s no guaranteed time frame.'],
      ['Can I color or perm Le Chic Beauty hair extensions?', 'You can color Le Chic Beauty hair extensions; a stylist gives the most seamless match, or do a strand test first at home. Perming isn’t recommended because it can dry out and damage the hair.'],
      ['Can I sleep or swim in halo hair extensions?', 'Sleeping in halo extensions isn’t recommended; they’re easy to take off and hang overnight. Swimming in them isn’t recommended unless you’re using the included optional clips.']
    ] }
  ];

  const faqHTML = `
    <div class="help-faq">
      ${faqGroups.map((g) => `
        <section class="faq-group" aria-labelledby="faq-${g.title.toLowerCase().replace(/\W+/g, '-')}">
          <h2 id="faq-${g.title.toLowerCase().replace(/\W+/g, '-')}">${e(g.title)}</h2>
          <div class="faq2-list">
            ${g.items.map(([q, a]) => `<details><summary>${e(q)}</summary><p>${e(a)}</p></details>`).join('')}
          </div>
        </section>`).join('')}
      <div class="faq-cta">
        <h2>Still need help?</h2>
        <p>Our Customer Care team is happy to help.</p>
        <a class="btn btn-dark" href="pages/contact.html">Contact Us</a>
      </div>
    </div>`;

  /* ---------- Render (preserve Liquid {% form 'contact' %} #help-form) ---------- */
  const tabs = Object.keys(pages).map((k) =>
    `<a class="tab${k === key ? ' is-active' : ''}" href="${LC.pageUrl(files[k])}"${k === key ? ' aria-current="page"' : ''}>${e(pages[k].label)}</a>`
  ).join('');

  const eyebrowEl = document.getElementById('help-eyebrow');
  const titleEl = document.getElementById('help-title');
  const introEl = document.getElementById('help-intro');
  const tabsEl = document.getElementById('help-tabs');
  const crumbEl = document.getElementById('help-crumb-current');
  if (eyebrowEl) eyebrowEl.textContent = page.eyebrow;
  if (titleEl) titleEl.textContent = page.title;
  if (introEl) introEl.textContent = page.intro;
  if (tabsEl) tabsEl.innerHTML = tabs;
  if (crumbEl) crumbEl.textContent = page.label;

  const faqRoot = document.getElementById('help-faq-root');
  if (key === 'faq' && faqRoot) {
    faqRoot.innerHTML = faqHTML;
  } else {
    const fieldsRoot = document.getElementById('help-form-fields');
    const asideRoot = document.getElementById('help-aside-root');
    const submitBtnEl = document.getElementById('help-submit-btn');
    const successIcon = document.getElementById('help-success-icon');
    if (fieldsRoot) fieldsRoot.innerHTML = forms[key].html;
    if (asideRoot) asideRoot.innerHTML = asides[key] || '';
    if (submitBtnEl) submitBtnEl.textContent = forms[key].submit;
    if (successIcon) successIcon.innerHTML = LC.icon('check');
    const helpForm = document.getElementById('help-form');
    if (helpForm) {
      helpForm.setAttribute('novalidate', '');
      helpForm.setAttribute('accept-charset', 'UTF-8');
    }
  }

  /* ---------- SEO ---------- */
  const crumbs = [['Home', 'index.html'], [page.label, path]];
  const allFaqs = faqGroups.flatMap((g) => g.items.map(([q, a]) => ({ q, a })));
  LC.seo({
    title: page.seoTitle,
    description: page.meta,
    path,
    jsonld: [
      LC.webPageLd(key === 'contact' ? 'ContactPage' : key === 'faq' ? 'FAQPage' : 'WebPage', path, page.seoTitle, page.meta, {
        breadcrumb: { '@id': `${LC.abs(path)}#breadcrumb` }
      }),
      Object.assign(LC.breadcrumbLd(crumbs), { '@id': `${LC.abs(path)}#breadcrumb` }),
      key === 'faq' ? Object.assign(LC.faqLd(allFaqs, path), { '@id': `${LC.abs(path)}#webpage` }) : null
    ]
  });

  const form = document.getElementById('help-form');
  /* Shopify redirects here with ?contact_posted=true after a native /contact success */
  if (form && /(?:\?|&)contact_posted=true(?:&|$)/.test(location.search || '')) {
    let first = (new URLSearchParams(location.search).get('lc_first') || 'there').replace(/[^\w\s.'-]/g, '').slice(0, 40) || 'there';
    let extra = '';
    try {
      const raw = sessionStorage.getItem('lc_help_success');
      if (raw) {
        const saved = JSON.parse(raw);
        sessionStorage.removeItem('lc_help_success');
        if (saved && saved.first) first = String(saved.first).replace(/[^\w\s.'-]/g, '').slice(0, 40) || first;
        if (saved && saved.emailFiles && saved.emailFiles.length) {
          extra = ' Please also email these files to ' + EMAIL + ' with your name: ' + saved.emailFiles.join(', ') + '.';
        } else if (saved && saved.attachedCount > 0) {
          extra = ' Your photo/PDF proof was included with this message.';
        }
      }
    } catch (err) {}
    document.getElementById('success-text').textContent = forms[key].success(first, extra);
    form.hidden = true;
    const success = document.getElementById('form-success');
    success.hidden = false;
  }
  if (!form) return;

  /* ---------- Dependent fields ---------- */
  const showField = (id, show) => {
    const wrap = form.querySelector(`[data-field="${id}"]`);
    if (!wrap) return;
    wrap.classList.toggle('is-hidden', !show);
    const ctrl = wrap.querySelector('input, select, textarea');
    ctrl.required = show;
    if (!show) { ctrl.value = ''; clearError(wrap); }
  };

  const productSel = form.querySelector('#product');
  if (productSel) {
    productSel.addEventListener('change', () => {
      const p = LC.findProduct(productSel.value);
      const colorSel = form.querySelector('#color');
      const opts = p && p.options.length > 1 ? p.options : [];
      colorSel.innerHTML = '<option value="">Select a color</option>' + opts.map((o) => `<option>${e(o.name)}</option>`).join('');
      showField('color', opts.length > 0);
    });
  }
  const fromSel = form.querySelector('#purchased-from');
  if (fromSel) fromSel.addEventListener('change', () => showField('retailer', fromSel.value === 'retailer'));

  /* File→base64 on change so submit can stay sync (native /contact submit). */
  const filePrep = new Map(); // input id -> { promise, result }
  const fieldLabel = (inp) => {
    const wrap = inp.closest('.hf');
    const labelEl = wrap && wrap.querySelector('.hf-label, label');
    return ((labelEl && labelEl.textContent) || inp.name || inp.id || 'File').replace(/\s*Optional\s*$/, '').trim();
  };
  form.querySelectorAll('.file-input').forEach((inp) => {
    const drop = inp.previousElementSibling;
    const names = form.querySelector(`#${inp.id}-names`);
    const update = () => {
      const list = Array.from(inp.files || []).map((f) => f.name);
      names.textContent = list.join(', ');
      drop.classList.toggle('has-files', list.length > 0);
    };
    const prep = () => {
      update();
      const label = fieldLabel(inp);
      if (!window.LC || typeof LC.prepareFiles !== 'function') {
        filePrep.set(inp.id, { promise: Promise.resolve({ attachments: [], emailFollowUp: [], used: 0 }), result: null });
        return;
      }
      const p = LC.prepareFiles(inp.files, label, 0).then((result) => {
        const cur = filePrep.get(inp.id);
        if (cur && cur.promise === p) cur.result = result;
        return result;
      });
      filePrep.set(inp.id, { promise: p, result: null });
    };
    inp.addEventListener('change', prep);
    ['dragenter', 'dragover'].forEach((t) => drop.addEventListener(t, (ev) => { ev.preventDefault(); drop.classList.add('is-drag'); }));
    ['dragleave', 'drop'].forEach((t) => drop.addEventListener(t, () => drop.classList.remove('is-drag')));
    drop.addEventListener('drop', (ev) => {
      ev.preventDefault();
      if (ev.dataTransfer.files.length) { inp.files = ev.dataTransfer.files; prep(); clearError(inp.closest('.hf')); }
    });
  });

  /* ---------- Validation ---------- */
  function messageFor(ctrl) {
    if (ctrl.validity.valueMissing) {
      if (ctrl.type === 'checkbox') return 'Please confirm to continue.';
      if (ctrl.type === 'file') return 'Please add a file.';
      if (ctrl.tagName === 'SELECT') return 'Please choose an option.';
      return 'Please fill this in.';
    }
    if (ctrl.validity.typeMismatch && ctrl.type === 'email') return 'Enter an email like name@example.com.';
    if (ctrl.validity.rangeOverflow) return 'The purchase date can’t be in the future.';
    return 'Please check this field.';
  }
  function clearError(wrap) {
    if (!wrap) return;
    wrap.classList.remove('is-invalid');
    const ctrl = wrap.querySelector('input, select, textarea');
    if (ctrl) ctrl.removeAttribute('aria-invalid');
    const err = wrap.querySelector('.hf-error');
    if (err) err.textContent = '';
  }
  function validate(ctrl) {
    const wrap = ctrl.closest('.hf');
    if (!wrap || wrap.classList.contains('is-hidden')) return true;
    if (ctrl.checkValidity()) { clearError(wrap); return true; }
    wrap.classList.add('is-invalid');
    ctrl.setAttribute('aria-invalid', 'true');
    wrap.querySelector('.hf-error').textContent = messageFor(ctrl);
    return false;
  }

  form.querySelectorAll('input, select, textarea').forEach((ctrl) => {
    ctrl.addEventListener(ctrl.type === 'checkbox' || ctrl.tagName === 'SELECT' || ctrl.type === 'file' ? 'change' : 'blur', () => {
      if (ctrl.closest('.hf').classList.contains('is-invalid') || ctrl.value) validate(ctrl);
    });
  });

  /* No-captcha mode: never keep captcha token fields — empty h-captcha-response can make
     Shopify reject the POST as "invalid parameters". Only Shopify contact schema fields. */
  const KEEP_NAMES = new Set(['form_type', 'utf8', 'contact[name]', 'contact[email]', 'contact[phone]', 'contact[body]']);
  const MAX_CONTACT_BODY = 90000; /* Shopify /contact rejects oversized bodies as invalid parameters */
  const stripDisplayNames = () => {
    form.querySelectorAll('input, select, textarea').forEach((c) => {
      if (!c.name) return;
      if (KEEP_NAMES.has(c.name)) return;
      c.dataset.lcName = c.name;
      c.removeAttribute('name');
    });
    /* File controls with a name force multipart and Shopify contact returns invalid parameters */
    form.querySelectorAll('input[type="file"]').forEach((c) => {
      if (c.name) {
        c.dataset.lcName = c.dataset.lcName || c.name;
        c.removeAttribute('name');
      }
    });
    form.querySelectorAll(
      'textarea[name="h-captcha-response"], input[name="h-captcha-response"], textarea[name="g-recaptcha-response"], input[name="g-recaptcha-response"], input[name="recaptcha-v3-token"]'
    ).forEach((el) => {
      el.removeAttribute('name');
    });
    try { form.setAttribute('enctype', 'application/x-www-form-urlencoded'); } catch (err) {}
  };
  const restoreDisplayNames = () => {
    form.querySelectorAll('input, select, textarea').forEach((c) => {
      if (c.dataset.lcName) {
        c.setAttribute('name', c.dataset.lcName);
        delete c.dataset.lcName;
      }
    });
  };

  const setContact = (id, value) => {
    const el = form.querySelector('#' + id) || form.elements[id.replace(/^lc-/, '').replace(/-/g, '')];
    // Prefer explicit ids on the Shopify contact hiddens
    const map = {
      'lc-contact-name': 'contact[name]',
      'lc-contact-email': 'contact[email]',
      'lc-contact-phone': 'contact[phone]',
      'lc-contact-body': 'contact[body]'
    };
    const node = document.getElementById(id);
    if (node) node.value = value == null ? '' : String(value);
  };

  const buildBody = async (label) => {
    const lines = [];
    const attachments = [];
    const emailFollowUp = [];
    let used = 0;

    // Wait for any in-flight file prep
    const pending = [];
    form.querySelectorAll('.file-input').forEach((inp) => {
      const wrap = inp.closest('.hf');
      if (wrap && wrap.classList.contains('is-hidden')) return;
      const entry = filePrep.get(inp.id);
      if (entry && entry.promise) pending.push(entry.promise.then(() => entry));
      else if ((inp.files || []).length && window.LC && typeof LC.prepareFiles === 'function') {
        const labelName = fieldLabel(inp);
        pending.push(LC.prepareFiles(inp.files, labelName, used).then((result) => {
          const e = { result };
          filePrep.set(inp.id, { promise: Promise.resolve(result), result });
          return e;
        }));
      }
    });
    const results = await Promise.all(pending);
    results.forEach((entry) => {
      const r = entry && entry.result;
      if (!r) return;
      (r.attachments || []).forEach((a) => {
        if (used + 1 > 0 && (a.dataUrl || '').length) {
          attachments.push(a);
        }
      });
      (r.emailFollowUp || []).forEach((f) => emailFollowUp.push(f));
    });
    // Re-check total budget across inputs
    let budget = 0;
    const kept = [];
    attachments.forEach((a) => {
      const approx = Math.round(((a.dataUrl || '').length) * 0.75);
      if (budget + approx > (LC.MAX_TOTAL || 700000)) {
        emailFollowUp.push({ field: a.field, file: a.fileName, reason: 'too large for form — email as attachment' });
      } else {
        kept.push(a);
        budget += approx;
      }
    });

    form.querySelectorAll('input, select, textarea').forEach((c) => {
      const wrap = c.closest('.hf');
      if (!c.name || (wrap && wrap.classList.contains('is-hidden'))) return;
      if (String(c.name).indexOf('contact[') === 0 || c.name === 'form_type' || c.name === 'utf8') return;
      const labelEl = c.id ? form.querySelector(`label[for="${c.id}"]`) : null;
      const name = ((labelEl && labelEl.textContent) || (wrap && wrap.querySelector('.hf-label') && wrap.querySelector('.hf-label').textContent) || c.name).replace(/\s*Optional\s*$/, '').trim();
      if (c.type === 'file') {
        const names = Array.from(c.files || []).map((f) => `${f.name} (${Math.round((f.size || 0) / 1024)} KB)`).join(', ');
        if (names) lines.push(`${name}: ${names}`);
        return;
      }
      let value;
      if (c.type === 'checkbox') value = c.checked ? 'Yes' : 'No';
      else if (c.tagName === 'SELECT') value = c.value ? (c.selectedOptions[0] || {}).textContent : '';
      else value = c.value;
      if (value) lines.push(`${name}: ${value}`);
    });

    if (kept.length) {
      lines.push('');
      lines.push('--- INLINE ATTACHMENTS (base64; Shopify contact has no file upload) ---');
      kept.forEach((a, i) => {
        lines.push(`Attachment ${i + 1}: ${a.field} / ${a.fileName} (${a.mime})`);
        lines.push(a.dataUrl);
      });
    }
    const care = (window.LC && LC.CARE_EMAIL) || EMAIL;
    if (emailFollowUp.length) {
      lines.push('');
      lines.push(`--- FILES TO EMAIL TO ${care} (not attached by Shopify contact form) ---`);
      emailFollowUp.forEach((f) => {
        lines.push(`- ${f.field}: ${f.file} (${f.reason})`);
      });
      lines.push(`Customer was asked to email these files to ${care} with their name and this submission.`);
    }
    let bodyText = `${label}\n\n${lines.join('\n')}`;
    let attachedCount = kept.length;
    /* Claim (multi photo) can blow past Shopify /contact limits → HTTP 400 invalid parameters.
       Drop inline base64 and ask customer to email files instead when over budget. */
    if (bodyText.length > MAX_CONTACT_BODY) {
      const withoutInline = [];
      let skip = false;
      lines.forEach((line) => {
        if (line.indexOf('--- INLINE ATTACHMENTS') === 0) { skip = true; return; }
        if (skip && line.indexOf('--- FILES TO EMAIL') === 0) { skip = false; }
        if (!skip) withoutInline.push(line);
      });
      kept.forEach((a) => {
        emailFollowUp.push({ field: a.field, file: a.fileName, reason: 'too large for Shopify contact form — email as attachment' });
      });
      if (emailFollowUp.length) {
        withoutInline.push('');
        withoutInline.push(`--- FILES TO EMAIL TO ${care} (not attached by Shopify contact form) ---`);
        emailFollowUp.forEach((f) => {
          withoutInline.push(`- ${f.field}: ${f.file} (${f.reason})`);
        });
        withoutInline.push(`Customer was asked to email these files to ${care} with their name and this submission.`);
      }
      bodyText = `${label}\n\n${withoutInline.join('\n')}`;
      attachedCount = 0;
      if (bodyText.length > MAX_CONTACT_BODY) {
        bodyText = bodyText.slice(0, MAX_CONTACT_BODY) + '\n\n[Truncated for Shopify contact form length limit.]';
      }
    }
    return {
      body: bodyText,
      attachedCount,
      emailFiles: emailFollowUp.map((f) => f.file),
      careEmail: care
    };
  };

  /* Submit (no theme captcha):
     Preferences hCaptcha should be OFF — post Liquid {% form 'contact' %} after body build.
     Skip Shopify.captcha.protect / hcaptcha.execute / token gate so no robot UI.
     data-nocaptcha skips Shopify form-persister auto-bind.
     Use requestSubmit() + lcAllowSubmit (NOT HTMLFormElement.prototype.submit) — matches the
     earlier working path; prototype.submit has caused Shopify "invalid parameters" on claim.
     Guard against re-entrant Enter submits during async file prep (claim race). */
  let lcSubmitting = false;
  let lcArmed = false;

  form.setAttribute('data-nocaptcha', 'true');

  form.addEventListener('submit', (ev) => {
    ev.preventDefault();
    ev.stopPropagation();
    if (typeof ev.stopImmediatePropagation === 'function') ev.stopImmediatePropagation();
    if (lcSubmitting) return;
    const controls = Array.from(form.querySelectorAll('input, select, textarea'));
    const invalid = controls.filter((c) => !validate(c));
    if (invalid.length) {
      const first = invalid[0];
      try {
        const wrap = first.closest('.hf');
        if (wrap && typeof wrap.scrollIntoView === 'function') {
          wrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      } catch (err) {}
      try { first.focus({ preventScroll: true }); } catch (err) { try { first.focus(); } catch (e2) {} }
      return;
    }
    lcSubmitting = true;
    const first = (form.querySelector('#first-name') || {}).value.trim() || 'there';
    const email = (form.querySelector('#email') || {}).value.trim();
    const phone = ((form.querySelector('#phone') || {}).value || '').trim();
    const last = ((form.querySelector('#last-name') || {}).value || '').trim();
    const fullName = `${first} ${last}`.trim();
    const submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Sending…'; }
    const label = pages[key] && pages[key].title ? pages[key].title : key;

    const fail = (msg) => {
      lcSubmitting = false;
      lcArmed = false;
      restoreDisplayNames();
      if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = forms[key].submit; }
      alert(msg || ('Sorry — we could not send your message. Please email ' + EMAIL + ' directly.'));
    };

    buildBody(label).then((pack) => {
      setContact('lc-contact-name', fullName);
      setContact('lc-contact-email', email);
      setContact('lc-contact-phone', phone);
      setContact('lc-contact-body', pack.body);

      try {
        sessionStorage.setItem('lc_help_success', JSON.stringify({
          key,
          first,
          attachedCount: pack.attachedCount,
          emailFiles: pack.emailFiles || []
        }));
      } catch (err) {}

      if (lcArmed) return;
      lcArmed = true;
      stripDisplayNames();
      /* Post with prototype.submit after strip — reliable from the async buildBody path.
         (requestSubmit after preventDefault often does not navigate in Chromium, which left
         Claim stuck on Sending…) Fields are already contact-schema only; body size capped. */
      HTMLFormElement.prototype.submit.call(form);
    }).catch(() => fail());
  }, true);


})();
